__turbopack_context__.v({
  "alertMessage": "SchoolFeedWidget-module-scss-module__g-Gasa__alertMessage",
  "allLinks": "SchoolFeedWidget-module-scss-module__g-Gasa__allLinks",
  "blocksBackgroundColor": "SchoolFeedWidget-module-scss-module__g-Gasa__blocksBackgroundColor",
  "blocksFontColor": "SchoolFeedWidget-module-scss-module__g-Gasa__blocksFontColor",
  "buttons": "SchoolFeedWidget-module-scss-module__g-Gasa__buttons",
  "cantEditContent": "SchoolFeedWidget-module-scss-module__g-Gasa__cantEditContent",
  "content": "SchoolFeedWidget-module-scss-module__g-Gasa__content",
  "contentContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__contentContainer",
  "dates": "SchoolFeedWidget-module-scss-module__g-Gasa__dates",
  "descriptionEditingInstructions": "SchoolFeedWidget-module-scss-module__g-Gasa__descriptionEditingInstructions",
  "error": "SchoolFeedWidget-module-scss-module__g-Gasa__error",
  "fetchMoreContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__fetchMoreContainer",
  "fileUrl": "SchoolFeedWidget-module-scss-module__g-Gasa__fileUrl",
  "header": "SchoolFeedWidget-module-scss-module__g-Gasa__header",
  "headerContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__headerContainer",
  "headerRightText": "SchoolFeedWidget-module-scss-module__g-Gasa__headerRightText",
  "headerRightTextThemeColor": "SchoolFeedWidget-module-scss-module__g-Gasa__headerRightTextThemeColor",
  "imageContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__imageContainer",
  "loadingSpinner": "SchoolFeedWidget-module-scss-module__g-Gasa__loadingSpinner",
  "localeSelector": "SchoolFeedWidget-module-scss-module__g-Gasa__localeSelector",
  "location": "SchoolFeedWidget-module-scss-module__g-Gasa__location",
  "logo": "SchoolFeedWidget-module-scss-module__g-Gasa__logo",
  "newsPostOption": "SchoolFeedWidget-module-scss-module__g-Gasa__newsPostOption",
  "newsPostOptionVertical": "SchoolFeedWidget-module-scss-module__g-Gasa__newsPostOptionVertical",
  "noPermissionText": "SchoolFeedWidget-module-scss-module__g-Gasa__noPermissionText",
  "openButton": "SchoolFeedWidget-module-scss-module__g-Gasa__openButton",
  "openEmbedMobileButton": "SchoolFeedWidget-module-scss-module__g-Gasa__openEmbedMobileButton",
  "popupArrow": "SchoolFeedWidget-module-scss-module__g-Gasa__popupArrow",
  "postAssignmentContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__postAssignmentContainer",
  "postContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__postContainer",
  "postManagerContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__postManagerContainer",
  "promptIsNotEditable": "SchoolFeedWidget-module-scss-module__g-Gasa__promptIsNotEditable",
  "reactDateTime": "SchoolFeedWidget-module-scss-module__g-Gasa__reactDateTime",
  "required": "SchoolFeedWidget-module-scss-module__g-Gasa__required",
  "schoolFeedLink": "SchoolFeedWidget-module-scss-module__g-Gasa__schoolFeedLink",
  "schoolfeed": "SchoolFeedWidget-module-scss-module__g-Gasa__schoolfeed",
  "scroller": "SchoolFeedWidget-module-scss-module__g-Gasa__scroller",
  "secondaryNavBackgroundColor": "SchoolFeedWidget-module-scss-module__g-Gasa__secondaryNavBackgroundColor",
  "subheader": "SchoolFeedWidget-module-scss-module__g-Gasa__subheader",
  "submitButton": "SchoolFeedWidget-module-scss-module__g-Gasa__submitButton",
  "submitButtonContainer": "SchoolFeedWidget-module-scss-module__g-Gasa__submitButtonContainer",
  "submitButtonDisabled": "SchoolFeedWidget-module-scss-module__g-Gasa__submitButtonDisabled",
  "themeBackgroundColor": "SchoolFeedWidget-module-scss-module__g-Gasa__themeBackgroundColor",
  "themeFontColor": "SchoolFeedWidget-module-scss-module__g-Gasa__themeFontColor",
  "timePicker": "SchoolFeedWidget-module-scss-module__g-Gasa__timePicker",
  "tooltip": "SchoolFeedWidget-module-scss-module__g-Gasa__tooltip",
  "topButtons": "SchoolFeedWidget-module-scss-module__g-Gasa__topButtons",
  "transitionEnter": "SchoolFeedWidget-module-scss-module__g-Gasa__transitionEnter",
  "transitionEnterActive": "SchoolFeedWidget-module-scss-module__g-Gasa__transitionEnterActive",
  "transitionEnterDone": "SchoolFeedWidget-module-scss-module__g-Gasa__transitionEnterDone",
  "transitionExit": "SchoolFeedWidget-module-scss-module__g-Gasa__transitionExit",
  "transitionExitActive": "SchoolFeedWidget-module-scss-module__g-Gasa__transitionExitActive",
  "transitionExitDone": "SchoolFeedWidget-module-scss-module__g-Gasa__transitionExitDone",
  "whiteContent": "SchoolFeedWidget-module-scss-module__g-Gasa__whiteContent",
});
